import { WellsFargoFileIngestion } from '@/api/wells-fargo/wells-fargo-file-ingestion';
import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components/ui/tooltip';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ArrowUpDown, Download, Eye } from 'lucide-react';
import { Link } from 'react-router';
import { DownloadFileIngestion } from './download-file-ingestion';

export const columns: ColumnDef<WellsFargoFileIngestion>[] = [
    {
        accessorKey: 'fileIngestionId',
        header: ({ column }) => (
            <Button
                variant="ghost"
                onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
            >
                File Id
                <ArrowUpDown />
            </Button>
        ),
        cell: ({ row }) => <div className="font-medium">{row.original.fileIngestionId}</div>,
    },
    {
        accessorKey: 'importDate',
        header: ({ column }) => (
            <Button
                variant="ghost"
                onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
            >
                Import Date
                <ArrowUpDown />
            </Button>
        ),
        cell: ({ row }) => {
            return (
                <div className="font-medium">
                    {row.original.importDate ? format(row.original.importDate, 'P') : '---'}
                </div>
            );
        },
    },
    {
		accessorKey: 'lockboxNumber',
		header: () => <div className="text-right">Lockbox Number</div>,
		cell: ({ row }) => (
			<div className="text-right font-medium">{row.original.lockboxNumber}</div>
		),
	},
    {
		accessorKey: 'numberOfChecks',
		header: () => <div className="text-right">Number of Checks</div>,
		cell: ({ row }) => (
			<div className="text-right font-medium">{row.original.numberOfChecks}</div>
		),
	},
    {
        accessorKey: 'totalAmount',
        header: () => <div className="text-right">Total Amount</div>,
        cell: ({ row }) => {
            let formattedAmount;
            if (row.original.totalAmount) {
                formattedAmount = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                }).format(row.original.totalAmount);
            }
            return <div className="text-right font-medium">{formattedAmount}</div>;
        },
    },
    {
        id: 'actions',
        cell: ({ row }) => (
            <div>
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Link to={`/wells-fargo/${row.original.fileIngestionId}`}>
                                <Button className="m-auto" variant="ghost">
                                    <Eye size={16} />
                                </Button>
                            </Link>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>View Transactions</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>

                <DownloadFileIngestion fileIngestionId={row.original.fileIngestionId} />
            </div>
        ),
    },
];
